import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';

import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';

const inputEl = document.querySelector('#datetime-picker');
const startBtnEl = document.querySelector('[data-start]');
const daysEl = document.querySelector('[data-days]');
const hoursEl = document.querySelector('[data-hours]');
const minutesEl = document.querySelector('[data-minutes]');
const secondsEl = document.querySelector('[data-seconds]');

if (
  !inputEl ||
  !startBtnEl ||
  !daysEl ||
  !hoursEl ||
  !minutesEl ||
  !secondsEl
) {
  console.warn('Timer elements not found on this page');
} else {
  let userSelectedDate = null;
  let timerId = null;

  startBtnEl.disabled = true;
  setTimerValues({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  const fp = flatpickr(inputEl, {
    enableTime: true,
    time_24hr: true,
    defaultDate: new Date(),
    minuteIncrement: 1,

    // ✅ Start активується одразу після вибору (без кліку поза формою)
    onChange(selectedDates, dateStr, instance) {
      const pickedDate = selectedDates[0];
      const now = new Date();

      if (!pickedDate || pickedDate <= now) {
        userSelectedDate = null;
        startBtnEl.disabled = true;

        iziToast.error({
          message: 'Please choose a date in the future',
          position: 'topRight',
          backgroundColor: '#EF4040',
          messageColor: '#ffffff',
          titleColor: '#ffffff',
          progressBarColor: '#B51B1B',
          closeOnClick: true,
        });

        return;
      }

      userSelectedDate = pickedDate;
      startBtnEl.disabled = false;

      // ✅ закриваємо календар вручну (прибирає “треба клікнути поза”)
      instance.close();
    },
  });

  startBtnEl.addEventListener('click', () => {
    if (!userSelectedDate) return;

    startBtnEl.disabled = true;
    inputEl.disabled = true;

    tick();
    timerId = setInterval(tick, 1000);
  });

  function tick() {
    const diff = userSelectedDate - new Date();

    if (diff <= 0) {
      clearInterval(timerId);
      timerId = null;

      setTimerValues({ days: 0, hours: 0, minutes: 0, seconds: 0 });

      inputEl.disabled = false;
      startBtnEl.disabled = true; // за ТЗ
      userSelectedDate = null;

      return;
    }

    setTimerValues(convertMs(diff));
  }

  function setTimerValues({ days, hours, minutes, seconds }) {
    daysEl.textContent = String(days).padStart(2, '0');
    hoursEl.textContent = String(hours).padStart(2, '0');
    minutesEl.textContent = String(minutes).padStart(2, '0');
    secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  function convertMs(ms) {
    const second = 1000;
    const minute = second * 60;
    const hour = minute * 60;
    const day = hour * 24;

    return {
      days: Math.floor(ms / day),
      hours: Math.floor((ms % day) / hour),
      minutes: Math.floor(((ms % day) % hour) / minute),
      seconds: Math.floor((((ms % day) % hour) % minute) / second),
    };
  }
}
